import { useParams } from 'react-router-dom';
import product from 'src/common/config/product';
import logger from 'src/logger';

export default (productId = '') => {
  const { productSlug } = useParams();

  let productKey;
  try {
    productKey = product.findKeyBy.sku(productId) ||
      product.findKeyBy.slug(productSlug);
  } catch (error) {
    logger.warn(error);
  }

  return productKey;
};
